<template>
    <div class="page-wrapper login-page">
        <Header/>
        <div class="wrapper">
            <div class="login-screen">
                <div class="eclipse">
                    <div class="vcenter-container">
                        <div class="vcenter"><img src="../image/eclipse.png"></div>
                    </div>
                </div>
                <div class="container">
                    <div class="content-block">
                        <div class="vcenter-container">
                            <div class="vcenter">
                                <div class="login-form">
                                    <div class="title">
                                        Авторизация
                                    </div>
                                    <div class="soc-links">
                                        <span class="soc facebook" @click="facebookLogin"><img src="@/image/facebook.svg" alt="Facebook"></span>
                                        <span class="soc google" @click="googleLogin"><img src="@/image/google-plus.svg" alt="Google+"></span>
                                        <div class="text">или</div>
                                    </div>
                                    <div class="form dark-bg-form">
                                        <fieldset>
                                            <div class="gradient-border">
                                                <div class="left"></div>
                                                <div class="right"></div>
                                                <input
                                                        name="email"
                                                        ref="email"
                                                        v-model.trim="email"
                                                        type="text"
                                                        autocomplete="off"
                                                        required
                                                        v-validate="'required|email'"
                                                        @keyup.enter="login"
                                                >
                                                <label>Email</label>
                                                <span v-show="errors.has('email')">{{ errors.first('email') }}</span>
                                            </div>

                                        </fieldset>
                                        <fieldset>
                                            <div class="gradient-border">
                                                <div class="left"></div>
                                                <div class="right"></div>
                                                <input
                                                        v-model="password"
                                                        name="password"
                                                        type="password"
                                                        autocomplete="off"
                                                        required
                                                        @keyup.enter="login"
                                                >
                                                <label>Пароль</label>
                                            </div>
                                        </fieldset>
                                        <div class="center">
                                            <button :disabled="isBlocked"
                                                    type="button" class="button white-button" @click="login">Войти</button>
                                        </div>
                                    </div>
                                    <div class="login-dop-links">
                                        <div class="string">
                                            <router-link to="/forgot-password"><a class="login-form-link login-form-link-opacity">Забыли пароль?</a></router-link>
                                        </div>
                                        <div class="string">
                                            <router-link to="/registration"><a class="login-form-link">Регистрация</a></router-link>
                                        </div>
                                    </div>
                                    <div class="dop-info-text">
                                        Авторизуясь с помощью соц. сетей, вы соглашаетесь с <router-link :to="{name: 'PrivacyPolicy'}" target="_blank">условиями обработки персональных данных</router-link> и с <router-link :to="{name: 'TermsOfUse'}" target="_blank">пользовательским соглашением</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="login-screen-bg bg-animation"></div>
            </div>
        </div>
        <Footer :no-footer="true"/>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import { Validator } from 'vee-validate';
    import constants from '@/constants';

    export default {
        name: 'Login',
        components: {
            Header, Footer
        },

        data() {
            return {
                email: '',
                password: '',
                isNoAccess: false
            }
        },

        mounted() {
            Validator.localize('en', constants.dictionary);
            this.$refs.email.focus()
        },

        computed: {
            isBlocked() {
                return !(Object.keys(this.fields).some(key => this.fields[key].valid) && this.password !== '');
            },
        },

        methods: {
            googleLogin() {
                window.location.href = constants.GOOGLE_AUTH_URL;
            },

            facebookLogin() {
                window.location.href = constants.FACEBOOK_AUTH_URL;
            },

            login () {
                if (!this.isBlocked) {
                    let userAuth = {
                        username: this.email,
                        password: this.password
                    };
                    this.$store.dispatch('authorization', userAuth);
                }
            }
        }
    }
</script>
